import {EntryType, OrderEntry, OrderSheetRegister, OrderSheetRegisterType, UrlQueryKey} from '@web/core/constants'
import {ROUTER_ORDER_RESULT, ROUTER_ORDER_SHEET_SELLER} from '@web/core/routes'
import {SHOPPING_BRANCH_CART, SHOPPING_CART, SHOPPING_CART_M, TIMELINE_MOBILE_URL, TIMELINE_URL} from '@web/core/urls'

export const getRouteUrl = () => {
    return {
        bridgeUrl: `${window.location.origin}${ROUTER_ORDER_SHEET_SELLER.POP_UP.BRIDGE}`,
        fdsAuthBridgeUrl: `${window.location.origin}${ROUTER_ORDER_SHEET_SELLER.FDS_AUTH_BRIDGE}`,
        changeMobilePinUrl: `${ROUTER_ORDER_SHEET_SELLER.POP_UP.CHANGE_MOBILE_PIN}`,
        cancelMobilePinUrl: `${ROUTER_ORDER_SHEET_SELLER.POP_UP.CANCEL_MOBILE_PIN}`,
        nonPurchasableUrl: `${ROUTER_ORDER_SHEET_SELLER.POP_UP.NON_PURCHASABLE}`,
    }
}

export const getResultUrl = ({orderNo}: {orderNo: string}) => {
    return {
        baseUrl: `${ROUTER_ORDER_RESULT.SELLER.getHref()}/${orderNo}`,
        routeUrl: `${ROUTER_ORDER_RESULT.SELLER}/${orderNo}`,
        giftUrl: `${ROUTER_ORDER_RESULT.SELLER}/${orderNo}?init=${UrlQueryKey.INIT_GIFT}`,
    }
}

export const getBackUrl = ({
    isPC,
    backUrl,
    sellerRegisterType,
    channel,
    productUrl,
}: {
    isPC: boolean
    backUrl: string
    sellerRegisterType: Maybe<OrderSheetRegisterType>
    channel: Maybe<EntryType>
    productUrl: string
}) => {
    const url = isPC ? TIMELINE_URL : TIMELINE_MOBILE_URL
    if (sellerRegisterType) {
        if (sellerRegisterType === OrderSheetRegister.IMMEDIATE_ORDER) {
            return backUrl || productUrl
        }
        if (sellerRegisterType === OrderSheetRegister.REPURCHASE) {
            return backUrl || url
        }
        if (sellerRegisterType === OrderSheetRegister.CART_ORDER) {
            if (channel === OrderEntry.BRANCH) {
                return SHOPPING_BRANCH_CART
            }
            return isPC ? SHOPPING_CART : SHOPPING_CART_M
        }
    }
    return ''
}
